<script>
  import GamesGame from './GamesGame.svelte';

  export let params;
</script>

{#key params.game}
  <GamesGame bind:params={params}/>
{/key}
